export default __webpack_public_path__ + "static/media/tunde.48923361.jpg";